import { render, staticRenderFns } from "./AddPrivilege.vue?vue&type=template&id=77f440a0"
import script from "./AddPrivilege.vue?vue&type=script&lang=js"
export * from "./AddPrivilege.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports